$(() => {
    if (document.getElementById('demo-client-clear') != null) {
        $('.modal-exec').on('click', function () {
            $('.js-button').prop('disabled', true);
            $(this).closest('#demo-client-clear').submit();
        });
    }
});
